import { useEffect } from 'react';

import { copyTemplate } from '@webapp/account/src/resources/survey';

import { useActions } from '@webapp/common/hooks/use-actions';
import { useRouteId } from '@webapp/common/hooks/use-route-id';

import css from './copy-template.css';

let initial = true;

export const CopyTemplate: FC = () => {
    const { id } = useRouteId();
    const copy = useActions(copyTemplate);

    useEffect(() => {
        if (initial) {
            initial = false;
            copy({ templateId: id });
        }
    }, [copy, id]);

    return (
        <div className={css.download}>
            <h3>
                <span>Копирование, скоро вы будете перенаправлены на опрос</span>{' '}
            </h3>
        </div>
    );
};
